// Arranque del tema: cada pieza revisa si su sección está en la página.
import { iniciarCarrito } from '@xic/carrito';
import { iniciarMedios } from '@xic/medios';
import { iniciarEscenas } from '@xic/escenas';
import { iniciarFicha } from '@xic/ficha';
import { iniciarLigas } from '@xic/ligas';
import { iniciarSaltos } from '@xic/saltos';
import { iniciarPromo } from '@xic/promo';

iniciarCarrito();
iniciarMedios();
iniciarEscenas();
iniciarFicha();
iniciarSaltos();
iniciarLigas();
iniciarPromo();
